import { utils } from 'frontend-js-shared'

import types from './organizationTypes'

const mutations = {
  [types.SET_ORGANIZATIONS](state, payload) {
    state.organizations = payload.organizations
  },

  [types.CLEAR_ORGANIZATIONS](state) {
    state.organizations = []
  },

  [types.SET_ACTIVE_ORGANIZATION](state, payload) {
    state.organization = payload.organization
  },

  [types.CLEAR_ACTIVE_ORGANIZATION](state) {
    state.organization = {}
  },

  [types.SET_ORGANIZATION_REVS](state, payload) {
    if (payload.revs.length > 0) {
      const ids = state.revs.map(item => {
        return item._id
      })

      payload.revs.forEach(value => {
        if (ids.indexOf(value._id) === -1) {
          state.revs.push(value)
        }
      })
    }
  },

  [types.CLEAR_ORGANIZATION_REVS](state) {
    state.revs = []
    state.paginatorAt = null
    state.pagerReachedTheEnd = false
    state.totalRevsLoaded = 0
  },

  [types.SET_ORGANIZATION_REVS_COUNTER](state, payload) {
    const totalAccountsInResponse = payload.totalRevsInResponse
    state.totalRevsLoaded =
      state.totalRevsLoaded + Number(totalAccountsInResponse)

    if (state.totalRevsLoaded >= payload.totalRevsInSystem) {
      state.pagerReachedTheEnd = true
    } else {
      state.pagerReachedTheEnd = false
    }
  },

  [types.CLEAR_ORGANIZATION_REVS_COUNTER](state) {
    state.totalRevsLoaded = 0
    state.pagerReachedTheEnd = false
  },

  [types.REMOVE_ORGANIZATION_REV](state, payload) {
    const revId = payload.revId

    state.revs = state.revs.filter(rev => {
      return rev._id.toString() !== revId.toString()
    })
  },

  [types.SET_ORGANIZATION_ACCOUNTS](state, payload) {
    if (payload.accounts.length > 0) {
      const ids = state.accounts.map(item => {
        return item._id
      })

      payload.accounts.forEach(value => {
        if (ids.indexOf(value._id) === -1) {
          state.accounts.push(value)
        }
      })
    }
  },

  [types.CLEAR_ORGANIZATION_ACCOUNTS](state) {
    state.accounts = []
  },

  [types.ADD_ORGANIZATION_ACCOUNT](state, payload) {
    const ids = state.accounts.map(item => {
      return item._id
    })

    if (ids.indexOf(payload.account._id) === -1) {
      state.accounts.push(payload.account)
    }
  },

  [types.SET_ORGANIZATION_CHALLENGES](state, payload) {
    if (payload.challenges.length > 0) {
      const ids = state.challenges.map(item => {
        return item._id
      })

      payload.challenges.forEach(value => {
        if (ids.indexOf(value._id) === -1) {
          state.challenges.push(value)
        }
      })
    }
  },

  [types.CLEAR_ORGANIZATION_CHALLENGES](state) {
    state.challenges = []
  },

  [types.SET_ORGANIZATION_CHALLENGES_COUNTER](state, payload) {
    const totalChallengesInResponse = payload.totalChallengesInResponse
    state.totalChallengesLoaded =
      state.totalChallengesLoaded + Number(totalChallengesInResponse)

    if (state.totalChallengesLoaded >= payload.totalChallengesInSystem) {
      state.pagerReachedTheEnd = true
    } else {
      state.pagerReachedTheEnd = false
    }
  },

  [types.CLEAR_ORGANIZATION_CHALLENGES_COUNTER](state) {
    state.totalChallengesLoaded = 0
    state.pagerReachedTheEnd = false
  },

  [types.SET_ORGANIZATION_PAGINATOR](state, payload) {
    state.paginators[payload.paginator] = payload.lastCursor
  },

  [types.CLEAR_ALL_ORGANIZATION_PAGINATORS](state) {
    state.paginators['challenges'] = null
    state.paginators['revs'] = null
  },

  [types.SET_ORGANIZATION_STATUS](state, payload) {
    const indexOfOrganizationInArray = state.organizations.findIndex(item => {
      return item._id === payload.organizationId
    })

    state.organizations[indexOfOrganizationInArray]['status'] =
      payload.newStatus
  },

  [types.SET_ORGANIZATION_LOGO](state, payload) {
    state.organizationLogo = payload
  },

  [types.CLEAR_ORGANIZATION_LOGO](state) {
    state.organizationLogo = null
  },

  [types.SET_ORGANIZATION_MOBILE_LOGO](state, payload) {
    state.organizationMobileLogo = payload.url
  },

  [types.CLEAR_ORGANIZATION_MOBILE_LOGO](state) {
    state.organizationMobileLogo = null
  },

  [types.SET_ORGANIZATION_STRUCTURE](state, payload) {
    const structure = payload.structure
    const sites = structure?.sites ?? []
    const tags = structure?.tags ?? []

    const siteGroupSiteIds = utils.getGroupItemIds(sites)
    const siteGroups = (structure?.siteGroups ?? []).map(group => {
      const groupId = utils.getEntityId(group)
      const groupSiteIds = new Set(siteGroupSiteIds[groupId] ?? [])
      return {
        ...group,
        sites: sites.filter(site =>
          groupSiteIds.has(utils.getEntityId(site))
        ),
      }
    })

    const tagGroupTagIds = utils.getGroupItemIds(tags)
    const tagGroups = (structure?.tagGroups ?? []).map(group => {
      const groupId = utils.getEntityId(group)
      const groupTagIds = new Set(tagGroupTagIds[groupId] ?? [])
      return {
        ...group,
        tags: tags.filter(tag => groupTagIds.has(utils.getEntityId(tag))),
      }
    })

    state.organizationStructure = { ...structure, siteGroups, tagGroups }
  },

  [types.CLEAR_ORGANIZATION_STRUCTURE](state) {
    state.organizationStructure = null
  },

  [types.SET_ORGANIZATION_CATEGORIES](state, payload) {
    state.organizationCategories = payload.categories
  },

  [types.CLEAR_ORGANIZATION_CATEGORIES](state) {
    state.organizationCategories = []
  },

  [types.SET_ORGANIZATION_SITUATION_TYPES](state, payload) {
    state.organizationSituationTypes = payload.situationTypes
  },

  [types.CLEAR_ORGANIZATION_SITUATION_TYPES](state) {
    state.organizationSituationTypes = []
  },

  [types.SET_ORGANIZATION_COUNTRY_CODES](state, payload) {
    state.organizationCountryCodes = payload.countryCodes
  },

  [types.CLEAR_ORGANIZATION_COUNTRY_CODES](state) {
    state.organizationCountryCodes = []
  },

  [types.SET_ORGANIZATION_AI_SETTINGS](state, payload) {
    state.organization = {
      ...state.organization,
      aiSettings: payload.organizationAISettings,
    }
  },
}

export default mutations
